export default "__VITE_ASSET__B$eZfTRi__"